export const iconFontAwesomeCodingSitemap = (
	<i className="fa-solid fa-sitemap"></i>
);
